import React, { FunctionComponent, useContext } from "react";
import { ListActionButtonProps } from "sprint-common-web";

import { AddToMergeListButton } from "../../../../../common/components/AddToMergeListButton";
import { TvSeriesPageContext } from "../../context/TvSeriesPageContext";
import { canSeasonsMerge } from "../canSeasonsMerge";
import { SeasonListingItem } from "../SeasonListingItem";

export const AddSeasonToMergeListButton: FunctionComponent<ListActionButtonProps> = (props: ListActionButtonProps) => {
    const { seasonsToMerge, listingItems, addSeasonToMergeList } = useContext(TvSeriesPageContext);

    const mergeButtonDisabled = (): boolean => {
        const item = listingItems.find((listingItem: SeasonListingItem) => listingItem.id === props.itemId);
        if (seasonsToMerge.length > 1) return true;

        return !canSeasonsMerge(seasonsToMerge[0], item);
    };

    const handleClick = () => {
        const item = listingItems.find((listingItem: SeasonListingItem) => listingItem.id === props.itemId);
        addSeasonToMergeList(item);
    };

    return <AddToMergeListButton disabled={props.disabled || mergeButtonDisabled()} onClick={handleClick} />;
};
